import gsap from 'gsap'

export const popup = () => {
	gallery()
	newsletter()
	general()
}

const gallery = () => {

	let els = document.querySelectorAll("[data-popup]")

	if (!els.length) return

	let target = document.querySelector('[data-modal-image]'),
		exits = document.querySelectorAll('[data-exit-modal]')

	els.forEach(el => {
		el.addEventListener("click", e => {
			e.preventDefault()
			document.body.setAttribute('data-modal-status', 'active')
			target.src = el.getAttribute('data-popup')
		})
	})

	exits.forEach(exit => {
		exit.addEventListener("click", () => {
			document.body.removeAttribute('data-modal-status')
		})
	})

	document.addEventListener("keydown", e => {
		if (e.key === "Escape") {
			document.body.removeAttribute('data-modal-status')
		}
	})
}

const newsletter = () => {

	let els = document.querySelectorAll("[data-newsletter-form]")

	if (!els.length) return

	let exits = document.querySelectorAll('[data-exit-newletter]')

	els.forEach(el => {
		el.addEventListener("click", e => {
			e.preventDefault()
			document.body.setAttribute('data-newsletter-status', 'active')
		})
	})

	exits.forEach(exit => {
		exit.addEventListener("click", () => {
			document.body.removeAttribute('data-newsletter-status')
		})
	})

	document.addEventListener("keydown", e => {
		if (e.key === "Escape") {
			document.body.removeAttribute('data-newsletter-status')
		}
	})
}

const general = () => {

	localStorage.setItem('popup-dismissed', 'false')

	const popup = document.querySelector("[data-popup-general]")

	if (!popup) return

	const exits = document.querySelectorAll('[data-exit-pop-up]')
	const hasShownPopup = localStorage.getItem('popup-dismissed')

	console.log('hasShownPopup', hasShownPopup)

	if (!hasShownPopup) return

	console.log('popup', popup)

	const handleScroll = () => {
		console.log('handleScroll')
		if (window.pageYOffset > 1920) {
			document.body.setAttribute('data-popup-status', 'active')
			window.removeEventListener('scroll', handleScroll)
		}
	}

	window.addEventListener('scroll', handleScroll)

	exits.forEach(exit => {
		exit.addEventListener("click", () => {
			document.body.removeAttribute('data-popup-status')
			localStorage.setItem('popup-dismissed', 'true')
		})
	})

	document.addEventListener("keydown", e => {
		if (e.key === "Escape") {
			document.body.removeAttribute('data-popup-status')
			localStorage.setItem('popup-dismissed', 'true')
		}
	})
}

export default () => { }